import { render } from "./WordStrips.vue?vue&type=template&id=01edbe9c&scoped=true"
import script from "./WordStrips.vue?vue&type=script&lang=js"
export * from "./WordStrips.vue?vue&type=script&lang=js"

import "./WordStrips.vue?vue&type=style&index=0&id=01edbe9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01edbe9c"]])

export default __exports__